import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { ContentTypes } from '../../util/ProductModalEnums';
import ColorDropdownSelectorItem from './ColorDropdownSelectorItem';
import './ColorDropdownSelector.css';
import { ProductModalContext } from '../../../ProductModalContext';
import { ColorSelectorOptionClicked } from '../../../../../../../utils/Analytics';

const ColorDropdownSelector = ({ defaultColor, fontStyle, groupColors, variants }) => {
    const { variantColor, setVariantColor, setSelectedVariantSKU, selectedVariantSKU, productVariantMap, baseSKU, productSKU, productInfo } = useContext(ProductModalContext)
    const [selectorOpen, setSelectorOpen] = useState(false);

    useEffect(() => {
        setVariantColor(productInfo.SIZE);
        // const productColorList = productVariantMap.features_map[defaultColor];
        // const selectedSKU = productColorList ? productColorList[Object.keys(productColorList)[0]] : null;
        setSelectedVariantSKU(productInfo.SKU);
        // setSelectedVariantSKU(productInfo.variants.features_map[defaultColor]);
    }, [])

    const toggleSelector = () => setSelectorOpen(!selectorOpen);

    const handleOnClick = (color) => {
        setVariantColor(color);
        ColorSelectorOptionClicked(productSKU, color)
        setSelectedVariantSKU(productInfo.variants.features_map[color]);
        toggleSelector();
    };

    return (
        <div id="color-selector-column" className="flex-center" style={fontStyle}>
            <ColorDropdownSelectorItem text={variantColor} sku={selectedVariantSKU} onClick={groupColors.length > 1 ? toggleSelector : () => { return; }} showArrow={groupColors.length > 1 && true} arrowDown={!selectorOpen} oneItem={groupColors.length <= 1} />

            <div id="color-selector-items" className="flex-center">
                {groupColors.length > 1 && <ColorDropdownSelectorItem text={variantColor ? variantColor : productInfo.SIZE} sku={selectedVariantSKU} relative={true} onClick={toggleSelector} showArrow={groupColors.length > 1 && true} arrowDown={!selectorOpen} />}
                {selectorOpen && groupColors && groupColors.length > 1 && groupColors.map((variant, index) => (
                    <ColorDropdownSelectorItem
                        key={index}
                        relative={true}
                        onClick={() => handleOnClick(variant)}
                        text={variant}
                    />
                ))}
            </div>
        </div>
    );
}

ColorDropdownSelector.propTypes = {
    groupProducts: PropTypes.array.isRequired,
    fontStyle: PropTypes.object,
    size: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired,
    fetchProductInfo: PropTypes.func.isRequired
};

export default ColorDropdownSelector;
